import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ThemeService {
  private readonly storageKey = '@wazir:dark-theme';
  private dark = false;

  constructor(@Inject(DOCUMENT) private document: Document) {}

  initialize(): void {
    this.dark = window.localStorage.getItem(this.storageKey) === 'true';
    this.applyTheme();
  }

  isDarkTheme(): boolean {
    return this.dark;
  }

  toggle(): boolean {
    this.dark = !this.dark;
    window.localStorage.setItem(this.storageKey, String(this.dark));
    this.applyTheme();
    return this.dark;
  }

  private applyTheme(): void {
    this.document.body.classList.toggle('system-dark-theme', this.dark);
  }
}
